import {useEffect} from 'react'
import {useAuthStore} from '../model/authStore'

export function AuthHydrate() {
  useEffect(() => {
    useAuthStore.getState().hydrate()
  }, [])
  return null
}
